import { Container } from 'react-bootstrap'

const ContentContainer = ({ children, ...props }) => <Container {...props}>{children}</Container>

ContentContainer.defaultProps = {
    fluid: 'md',
}

export default ContentContainer
